import {
  logEvent,
  setUserId,
  setUserProperties,
  setDefaultEventParameters
} from 'firebase/analytics'
import { analytics } from '@/plugins/firebase'
import { sendEventBrevo, sendIdentifyBrevo, sendPageBrevo } from './brevo'
import { useAnalyticsStore } from '@/store/app'
import { isDev } from '@/utils/environment'
import { getDeviceName } from '@/utils/device'

const sendEvent = (eventName: string, params: any = {}) => {
  console.log(eventName)
  console.log(params)
  const marketingParams = addMarketingParams()
  console.log(marketingParams)
  const allParams = { ...params, ...marketingParams }
  if (isDev) return

  logEvent(analytics, eventName, allParams)
  sendEventBrevo(eventName, allParams)
}

const setUserID = (user: any) => {
  // console.log(user.id)
  if (isDev) return

  setUserId(analytics, user.id.toString())
}

const setUserProps = (user: any, child: any) => {
  if (isDev) return

  console.log('User Properties')
  setUserProperties(analytics, {
    ...user,
    subscription: user.subscription?.id,
    children: user.children.map((it: any) => it.id).join(','),
    children_names: user.children.map((it: any) => it.name).join(','),
    subscribed: user.subscription?.active,
    subscription_product_id: user.subscription?.productId,
    user_neurodiversity: user.children.some((it: any) => {
      it.neurodiversity != null &&
        !it.neurodiversity.includes('NO') &&
        !it.neurodiversity.includes('NA') &&
        !it.neurodiversity.includes('NONE')
    })
      ? 'NEE'
      : 'NO_NEE',
    child_id: child.id,
    child_name: child.name,
    child_birth: child.birth,
    child_locale: child.locale,
    child_stimuli: child.stimuli,
    child_time: child.timeLimit,
    child_time_limit: child.timeLimitSettings?.timeLimit,
    child_time_limit_left: child.timeLimitSettings?.timeLimitMinutesLeft.toString(),
    child_neurodiversity: child.neurodiversity?.join(''),
    child_sound: child.sound,
    child_locution_volume: child.soundSettings?.locutionVolume.toString(),
    child_fx_volume: child.soundSettings?.musicFxVolume.toString()
  })

  sendIdentifyBrevo(user, child)
}

const setDefaultProps = (props: any) => {
  // console.log(props)
  if (isDev) return

  const propsAux = {
    version: '2.0.0',
    platform: 'web',
    device_model: getDeviceName(),
    device_locale: navigator.language
  }

  setDefaultEventParameters(propsAux)
}

const addMarketingParams = (params: any = {}) => {
  const analyticsStore = useAnalyticsStore()
  const paramsAux: { [key: string]: any } = {}
  if (analyticsStore.queryParams['utm_source']) {
    paramsAux.utm_source = analyticsStore.queryParams['utm_source']
    paramsAux.source = analyticsStore.queryParams['utm_source']
  }
  if (analyticsStore.queryParams['utm_medium']) {
    paramsAux.utm_medium = analyticsStore.queryParams['utm_medium']
    paramsAux.medium = analyticsStore.queryParams['utm_medium']
  }
  if (analyticsStore.queryParams['utm_campaign']) {
    paramsAux.utm_campaign = analyticsStore.queryParams['utm_campaign']
    paramsAux.campaign = analyticsStore.queryParams['utm_campaign']
  }
  if (analyticsStore.queryParams['utm_id']) {
    paramsAux.campaign_id = analyticsStore.queryParams['utm_id']
  }
  if (analyticsStore.queryParams['gad_source']) {
    paramsAux.gad_source = analyticsStore.queryParams['gad_source']
    paramsAux.gclid = analyticsStore.queryParams['gad_source']?.split('gclid=')[1]
  }
  return { ...params, ...analyticsStore.queryParams, ...paramsAux }
}

const setCurrentScene = (params: any) => {
  console.log(`${params.to.name.toLowerCase()}_viewed`)
  console.log(params.source)
  if (isDev) return

  const eventParams: any = {
    to: params.to.name,
    from: params.from.name,
    source: params.source
  }
  logEvent(analytics, 'page_view')
  logEvent(analytics, `${params.to.name.toLowerCase()}_viewed`, { source: params.source })
  logEvent(analytics, 'screen_view', eventParams)
  sendPageBrevo(params)
}

export { sendEvent, setUserID, setUserProps, setDefaultProps, setCurrentScene }
